class SnowplowContext {
  constructor(schema, actionMap) {
    this.schema = schema
  }

  getSchema() {
    return this.schema
  }

  analytics(data) {
    return {
      schema: this.schema,
      data
    }
  }
}

export {SnowplowContext}

export default SnowplowContext
